import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const login = async(payload) => {
  let res = await Services.POST(Url.LOGIN, payload)
  return res;
};

export const getUserDetail = async() => {
  let res = await Services.GET(Url.GET_USER_DETAIL)
  return res;
};

export const changePassword = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.CHANGE_PASSWORD}/${id}`, payload, token)
  return res;
};
